"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.win = void 0;
// Jest with JSDOM doesn't allow to override some window props, e.g. window.top, window.parent
// To be able to test different scenarios (multiple frames on the page, current frame is not top) need to proxy
// window object via this module, so it'll possible to mock it in test environment
exports.win = window;
//# sourceMappingURL=index.js.map